// extracted by mini-css-extract-plugin
module.exports = {"eventImage":"EventImage_eventImage__3yTPR"};